import { useCallback, useMemo } from 'react'

import { usePreviewWorksheet } from 'src/legacy_modules/dashboard/trial/detail/template/common/detail/preview/preview-worksheet-context'
import { ItemType } from 'src/legacy_modules/entities/small-item/entity'
import { SmallItemAnswer } from 'src/legacy_modules/entities/small-item-answer/entity'

export const useSmallItemAnswerForm = (smallItemAnswer: SmallItemAnswer) => {
  const { updateSmallItemAnswer, updateChoiceAnswer } = usePreviewWorksheet()

  const value = useMemo(
    () => smallItemAnswer.value ?? '',
    [smallItemAnswer.value],
  )

  const setValue = useCallback(
    (value: string) => {
      updateSmallItemAnswer({
        smallItemAnswerUid: smallItemAnswer.uid,
        value,
      })
    },
    [updateSmallItemAnswer, smallItemAnswer.uid],
  )
  const updateChoice = useCallback(
    (choiceAnswerUids: string[]) => {
      updateChoiceAnswer({
        smallItemAnswerUid: smallItemAnswer.uid,
        selectedChoiceAnswerUids: choiceAnswerUids,
      })
    },
    [updateChoiceAnswer, smallItemAnswer.uid],
  )

  const selectedChoiceAnswerUids = useMemo(
    () =>
      smallItemAnswer.choiceAnswers.filter(ca => ca.checked).map(ca => ca.uid),
    [smallItemAnswer.choiceAnswers],
  )

  const onToggleChoiceAnswer = useCallback(
    (uid: string) => {
      if (
        [ItemType.Radio, ItemType.SelectMenu].includes(smallItemAnswer.itemType)
      ) {
        updateChoice([uid])
        return
      }

      if (smallItemAnswer.itemType === ItemType.CheckBox) {
        const checked = selectedChoiceAnswerUids.includes(uid)

        if (checked) {
          updateChoice(
            selectedChoiceAnswerUids.filter(selectedUid => uid !== selectedUid),
          )
        } else {
          updateChoice(selectedChoiceAnswerUids.concat([uid]))
        }
      }
    },
    [selectedChoiceAnswerUids, smallItemAnswer.itemType, updateChoice],
  )

  const onRemoveSelected = useCallback(
    (clickedValue: string) => {
      if (selectedChoiceAnswerUids[0] === clickedValue) {
        updateChoice([])
      }
    },
    [selectedChoiceAnswerUids, updateChoice],
  )

  const onUnselect = useCallback(() => {
    updateChoice([])
  }, [updateChoice])

  return {
    value,
    setValue,
    selectedChoiceAnswerUids,
    onToggleChoiceAnswer,
    onRemoveSelected,
    onUnselect,
  }
}
